import { cn } from "ui";

import { type MinimapInstruction } from "./minimapUtils";

interface MinimapDropIndicatorProps {
  instruction: MinimapInstruction;
  level: number;
}

export function MinimapDropIndicator(props: MinimapDropIndicatorProps) {
  const leftOffset = props.level * 12 + 4;

  if (props.instruction === "make-child") {
    return (
      <div
        className={cn(
          "absolute inset-0 border-2 border-dashed border-amber-400 bg-amber-50/30 rounded pointer-events-none",
        )}
      />
    );
  }

  const isAbove = props.instruction === "reorder-above";

  return (
    <div
      className={cn(
        "absolute right-0 h-0.5 bg-amber-500 pointer-events-none",
        isAbove ? "-top-[5px]" : "-bottom-[5px]",
      )}
      style={{ left: `${leftOffset}px` }}
    >
      <div
        className={cn(
          "absolute w-2 h-2 rounded-full bg-amber-500",
          "-top-[3px] -left-1",
        )}
      />
    </div>
  );
}
